<template>
    <div class="my-vip-act-button-box" @click="clickVipButton">
        <button class="my-vip-act-button"></button>
        <div class="my-vip-act-time">{{timeStr}}</div>
    </div>
</template>

<script>
import { UTILS } from '../../modules/utils';
export default {
    name: 'MyVipActBtn',
    computed: {
        vipCountTime() {
            return this.$store.state.reminder.vipCountTime
        },
    },
    data() {
        return {
            timeStr: '',
            timeFunc: undefined
        }
    },
    mounted() {
        this.startAni();
    },
    destroyed() {
        this.clearAni();
    },
    methods: {
        clickVipButton() {
            var userData = this.$store.state.userData.info;
            this.$store.state.user.curVipPayType = userData && userData.donate == 1 ? 3 : 4;
            this.$store.state.user.showMyVip = true;
            var me = this;
            setTimeout(() => {
                me.$bus.emit('initMyVipPage');
                me.$bus.emit('startMyVipAni');
            }, 20);
        },
        startAni() {
            var me = this, 
                lsTime = localStorage.getItem('h5_vip_count_time'),
                startTime = lsTime && parseInt(lsTime) != 0 ? parseInt(lsTime) : startTime;
            console.error('startAni', this.vipCountTime, lsTime)
            if(me.timeFunc) { clearTimeout(me.timeFunc) };
            function count() {
                me.timeStr = UTILS.getTimeStrBySecond(startTime);
                // console.error('count-----', me.timeStr)
                if(startTime == 0) {
                    me.timeStr = '';
                    me.$store.state.reminder.showVipPop = false;
                    me.$store.state.user.curVipPayType = 2;
                    clearTimeout(me.timeFunc);
                }else {
                    startTime--;
                    window.localStorage.setItem('h5_vip_count_time', startTime);
                    me.timeFunc = setTimeout(() => {
                        count();
                    }, 1000);
                }
            }
            if(startTime == 0) { 
                me.timeStr = '';
                return;
            }
            count();

        },
        clearAni() {
            clearTimeout(this.timeFunc);
        }
    }
}
</script>